import React, {Fragment, useState} from 'react';
import PropTypes from 'prop-types';
import {connect, useSelector} from 'react-redux';
import Spinner from '../layout/Spinner';
import Table from 'react-bootstrap/Table';
import CustomPagination from '../layout/CustomPagination';
import ClientItem from "./ClientItem";
import {getClients} from "../../actions/client";
import ClientCreateForm from "./ClientCreateForm";
import ClientDeleteForm from "./ClientDeleteForm";
import ClientUpdateForm from "./ClientUpdateForm";
import SearchForm from "../layout/SearchForm";
import {Plus} from "react-feather";

const Clients = (props) => {

    const {
        auth
    } = useSelector(state => state);
    const {role_name} = auth?.user || {};

    const {clients, loading, numberOfPages, currentPage, total_clients} = useSelector(state => state.client);

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <Fragment>
            <div className={`loader-container ${loading ? 'loading' : ''} `}></div>
            <div className="container-fluid p-0">

                <div className="row mb-2">
                    <div className="col-md-12 col-lg-8">
                        <h1 className="h3 mb-3"><strong></strong> mijozlar({total_clients}) </h1>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6">
                        <SearchForm getPageItems={getClients}/>
                    </div>
                    <div className="col-md-6">
                        <div className="crud_actions text-end">
                            <button className="btn btn-primary" onClick={handleShow}>
                                Klient <Plus/>
                            </button>
                        </div>
                    </div>
                </div>

                <div className="row mt-2">
                    <div className="col-xl-12 col-xxl-12 d-flex">

                        <div className="card w-100 table-responsive">
                            <Table responsive="sm">

                            </Table>
                            <table className="table custom-table table-hover">
                                <thead className="table-light">
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">Nomi</th>
                                    <th scope="col">Yetkazuvchi</th>
                                    <th scope="col">Tashkilot xodimi</th>
                                    <th scope="col">INN</th>
                                    <th scope="col">Telefon</th>
                                    <th scope="col">Turi</th>
                                    <th scope="col">Bank hisob raqami</th>
                                    <th scope="col">Amallar</th>
                                </tr>
                                </thead>
                                <tbody>
                                {clients.map((item, index) => (
                                    <ClientItem key={`employee${item.id}`} number={index + 1} client={item}/>
                                ))}
                                </tbody>
                            </table>

                        </div>

                    </div>
                </div>

                <div className="row">
                    <div className="col-xl-12 col-xxl-12 d-flex">
                        <CustomPagination
                            numberOfPages={numberOfPages}
                            getPageItems={getClients}
                            current_page={currentPage}
                        />
                    </div>
                </div>

            </div>


            <ClientCreateForm show={show} handleShow={handleShow} handleClose={handleClose}/>

            <ClientDeleteForm/>

            <ClientUpdateForm/>


        </Fragment>
    );
};


Clients.propTypes = {
    getClients: PropTypes.func.isRequired,
    client: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
    client: state.client,
});

export default connect(mapStateToProps, {getClients})(Clients);
